/*! TWire JS helper functions - MIT license */
import util   from './twire.util';
import forms  from './twire.forms';
import stripe from './twire.stripe';

export default {

	util:	util,
	forms:	forms,
	stripe:	stripe,
	init: 	function(parent = document) {
		
		var _self = this;

		var $parent = $(parent);
		var $window = $(window);
	
		
		// Pseudo form
		$parent.find('div.twire-pseudo-form').each(function() {

			var $this = $(this);

			// Add the form tag
			var $form = $this.wrap('<form></form>')
							 .closest('form');

			// Add the attributes
			var attributes = $this.prop('attributes');

			// Copy over attributes
			$.each(attributes, function() {
				
				$form.attr(this.name, this.value);
				
			});
			
			// Copy method and action and remove data- counterparts
			$form.attr('method', $this.data('method'));
			$form.attr('action', $this.data('action'));
			$form.attr('data-method', null);
			$form.attr('data-action', null);

			// Get rid of the dummy tag
			$this.replaceWith($this.children());
							 
		});
		
		// Set time and GUID for all forms so they work with caching
		$parent.find('form.twire-validated-form').each(function() {
			
			var $form 			= $(this);
			
			var unixTimestamp 	= _self.util.getUNIXTimestamp();
			var guid 			= _self.util.generateGUID();
		
			$form.find('input[name="twire-t"]').val(unixTimestamp);
			$form.find('input[name="twire-guid"]').val(guid);
		
		});


		// Trigger window load after a time
		// (in case third-party scripts delay event and therefore local scripts that reply in window loaded)
		// Defaults to 5 seconds, can be overridden using body[data-loaded-handler-timeout]
		// Set to 0 to disable
		if (document.readyState !== 'complete') { // If this gets called again the window has loaded so this code is not required

			window.twireLoadedHandlerCalled = false;

			var loadedHandlerTimeout = typeof $('body').data('twire-loaded-handler-timeout') == 'undefined' ? 5000 : parseInt($('body').data('twire-loaded-handler-timeout'));

			if (loadedHandlerTimeout != 0) {

				$window.on('load.twire.twire-core', function() {
					 
					window.twireLoadedHandlerCalled = true;
					 
				});
				 
				setTimeout(function() {
					 
					if (window.twireLoadedHandlerCalled === false) {
				 
						 window.dispatchEvent(new Event('load'));
						
					}
				 
				}, loadedHandlerTimeout);

			}	

		} else {

			// The window has already loaded so trigger the laod event
			window.dispatchEvent(new Event('load'));

		}
		

		// Init forms
		_self.forms.addValidationHandler();
		
	}

};
